import React from "react"
import ResendEmail from "../admin/ResendEmail"

class FixEmail extends React.Component{

  constructor(props) {
    super(props);

    this.touchSystemNotification = this.touchSystemNotification.bind(this)
  }

  render() {
    var failedRecipient = this.getFailedRecipient();
    return (
      <div>
        <div className="alert alert-warning text-center">{failedRecipient ? <div style={{marginBottom: 15, paddingBottom: 15, borderBottom: '1px solid #c4ac85'}}>{I18n.t('email_recipient')}: <strong>{failedRecipient}</strong></div> : null} {this.props.system_notification.text}</div>
        <ResendEmail email={this.props.email_log} path={this.props.resend_email_path} onSuccess={this.touchSystemNotification} />
      </div>
    );
  }

  touchSystemNotification(msg) {
    var self = this;

    if (msg && top.successGrowl) {
      top.successGrowl(msg);
    }

    if (top.touchSystemNotification) {
      top.touchSystemNotification(self.props.system_notification.id);
    }
  }

  getFailedRecipient() {
    for (var i = 0, ilen = this.props.email_log.email_log_events.length; i < ilen; i++) {
      var email_log_event = this.props.email_log.email_log_events[i];

      if (email_log_event.event_name == 'failed') {
        return email_log_event.recipient;
      }
    }
  }
};

export default FixEmail
